import { ConfirmDialog } from '@amelio/ui-library';

import type { User } from '@/types/directory/User';

import { useAmelioTranslations } from '@/hooks';
import { getFullName } from '@/utils/user';

interface SubmittedRemovalConfirmDialogProps {
    /** The respondent about to be removed after submitting their answers; the dialog is closed while there is none. */
    reviewer?: User;
    onAnswer: (confirmed: boolean) => void;
}

/** Names the respondent about to be removed and says that their answers and comments go with them. */
export const SubmittedRemovalConfirmDialog = ({
    reviewer,
    onAnswer,
}: SubmittedRemovalConfirmDialogProps) => {
    const { t } = useAmelioTranslations();

    const values = { name: reviewer && getFullName(reviewer) };

    return (
        <ConfirmDialog
            isOpen={Boolean(reviewer)}
            title={t('evaluation360AssignReviewers.confirmSubmittedRemoval.title', values)}
            message={t('evaluation360AssignReviewers.confirmSubmittedRemoval.message', values)}
            confirmLabel={t('evaluation360AssignReviewers.confirmSubmittedRemoval.confirm')}
            cancelLabel={t('common.cancel')}
            confirmTone={'danger'}
            onConfirm={() => onAnswer(true)}
            onCancel={() => onAnswer(false)}
        />
    );
};
